import { useMemo } from "react";
import ReactECharts from "echarts-for-react";
import { useSelector } from "react-redux";
import { Panel } from "rsuite";
import { useTranslation } from "react-i18next";
import { PARAMS } from "../util/GlobalConstants";
import MessageBox from "./MessageBox";

const OsVersionChart = ({ devices = [] }) => {
  const [t] = useTranslation();
  const theme = useSelector((state) => state.theme.currentTheme);
  const textColor = theme === PARAMS.theme.light ? "#222b45" : "#fff";
  const accent =
    theme === PARAMS.theme.light ? "#3366ff" : "#588aff";

  const { labels, values } = useMemo(() => {
    const counts = {};
    devices.forEach((d) => {
      const os = (d.os || "—").trim();
      counts[os] = (counts[os] || 0) + 1;
    });
    const sorted = Object.entries(counts).sort((a, b) => a[1] - b[1]);
    return {
      labels: sorted.map((x) => x[0]),
      values: sorted.map((x) => x[1]),
    };
  }, [devices]);

  if (devices.length === 0) {
    return (
      <Panel className="content">
        <MessageBox message={t("_common.empty-message")} />
      </Panel>
    );
  }

  const option = {
    grid: { left: 8, right: 28, top: 10, bottom: 10, containLabel: true },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      backgroundColor: "rgba(22, 22, 45, 0.85)",
      textStyle: { color: "#fff" },
      borderWidth: 0,
    },
    xAxis: {
      type: "value",
      splitLine: { lineStyle: { color: "rgba(143,155,179,0.15)" } },
      axisLabel: { color: textColor },
    },
    yAxis: {
      type: "category",
      data: labels,
      axisLine: { lineStyle: { color: "rgba(143,155,179,0.3)" } },
      axisLabel: { color: textColor, fontWeight: 600 },
    },
    series: [
      {
        type: "bar",
        data: values,
        barWidth: "55%",
        label: { show: true, position: "right", color: textColor, fontWeight: 700 },
        itemStyle: {
          borderRadius: [0, 6, 6, 0],
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [
              { offset: 0, color: accent },
              { offset: 1, color: "#2de69a" },
            ],
          },
        },
      },
    ],
  };

  const height = Math.max(140, labels.length * 44 + 30);

  return (
    <Panel className="content">
      <ReactECharts option={option} style={{ height }} />
    </Panel>
  );
};

export default OsVersionChart;
